import { render, staticRenderFns } from "./ManageNotificationDetails.vue.js?vue&type=template&id=286fa51f&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationDetails.vue?vue&type=template&id=286fa51f&scoped=true"
import script from "./ManageNotificationDetails.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationDetails.vue?vue&type=script&lang=js"
export * from "./ManageNotificationDetails.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationDetails.vue?vue&type=script&lang=js"
import style0 from "./ManageNotificationDetails.vue.scss?vue&type=style&index=0&id=286fa51f&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationDetails.vue?vue&type=style&index=0&id=286fa51f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fa51f",
  null
  
)

export default component.exports